const url = {
    //Local
    localBack: 'https://localhost:44308',
    localFront: 'https://localhost:44320',
    //localBack: 'http://localhost:6586',
    //localFront: 'http://localhost:14518',    
    cas: 'https://auth.test.espol.edu.ec',
    foto: 'http://192.168.253.6:8001/api/Carnet/ByToken?idApp=',
    CAS_FOTO: 'http://192.168.253.6:8085/token?idApp='
    //Sever-Pruebas
    //localBack : 'http://192.168.253.6:8002',
    //localFront : 'http://192.168.253.7:8002',
    //cas: 'http://auth.test.espol.edu.ec',
}

export default url;
